<template>
  <section id="privacy-policy" class="container section">
    <div class="columns is-centered">
      <div class="column is-half-fullhd">
        <h1 class="title">{{ $t("privacy.header") }}</h1>
        <p class="content" v-html="$t('privacy.desc')"></p>

        <div class="content" v-for="n in 7" :key="n">
          <h3 class="title" v-html="$t(`privacy[${n}].title`)"></h3>
          <div v-html="$t(`privacy[${n}].text`)"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
// Немає потреби у defineComponent у <script setup>
</script>

<style scoped lang="scss">
#privacy-policy {
  h1 {
    font-size: 2em;
    margin-bottom: 1em;
  }

  .title {
    color: var(--font-color);
  }
}
</style>
